export const SPIORetryCount = 2

export const getStatusPageErrorMessage = (
  status: number,
  method: string,
  resource: string
) => `StatusPage ${status}: ${method} call failed for ${resource}`
